import "./App.css";
import { useState, useEffect, useRef, Suspense, createContext } from "react";
import { useDispatch } from "react-redux";
import AllRoutes from "./Routes/index";
import { ToastContainer, toast } from 'react-toastify';
import { requestPermission, onMessageListener } from "Services/push-notification";
import { getCommon, getTranslations, getLocation } from "Slices/thunks";
import Loader from "Components/Common/Loader";
import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material";
import theme from "./Theme/theme";
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import "swiper/css";
import "swiper/css/navigation";

const ltrCache = createCache({
  key: 'mui',
});

// Create rtl cache
const rtlCache = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

export const DirectionContext = createContext();

function App() {
  const language = localStorage.getItem('LANGUAGE') || "en";
  const [direction, setDirection] = useState(language === "en" ? "ltr" : "rtl");
  const dispatch = useDispatch();

  const sdkStatus = useRef("Pending");

  const changeDirection = (lang) => {
    const dir = lang === "en" ? "ltr" : "rtl";
    localStorage.setItem("LANGUAGE", lang);
    localStorage.setItem("langId", lang === "en" ? 1 : 2);
    // setDirection(dir);
    window.location.reload();
  };

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      // script.onload = resolve;
      // script.onerror = reject;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(script);
  });
  
  useEffect(() => {
    document.body.dir = direction; // Set the document direction based on the state

    dispatch(getCommon());
    dispatch(getTranslations());
    // dispatch(getLocation());

    if (sdkStatus.current === "Pending") {
      sdkStatus.current = "Loading";
      Promise.all([
        // loadScript("https://sdk.netless.link/white-web-sdk/2.16.43.js"),
        // loadScript("https://whiteboard-coded-plus.web.app/whiteboard.js")
        // loadScript("https://coded-plus-whiteboard--testing-7xad53u4.web.app/whiteboard.js")
      ]).then(() => {
        sdkStatus.current = "Completed";
        console.log("SDK scripts loaded successfully");
      }).catch(err => {
        console.error("Failed to load SDK scripts", err);
      });
    }

    // if ("serviceWorker" in navigator) {
    //   navigator.serviceWorker
    //     .register("/firebase-messaging-sw.js")
    //     .then((registration) => {
    //       console.log("Service Worker registered with scope:", registration.scope);
    //     })
    //     .catch((err) => {
    //       console.error("Service Worker registration failed:", err);
    //     });
    // }

    // requestPermission();

    // onMessageListener().then((payload) => {
    //   console.log("Foreground message received:", payload);
    //   // Optionally show a notification here
    //   alert(payload.notification.title + "\n" + payload.notification.body);
    // });
  }, [])

  return (
    <DirectionContext.Provider value={{ direction, changeDirection }}>
      <CacheProvider value={direction === "rtl" ? rtlCache : ltrCache}>
        <ThemeProvider theme={createTheme({...theme, direction: direction})}>
          <ToastContainer
            position="top-center"    
            hideProgressBar          
            closeButton={false}    
            autoClose={3000}         
            newestOnTop={true}         
            draggable={false}          
          />
          <Suspense fallback={() => <Loader />}>
            <AllRoutes />
          </Suspense>
        </ThemeProvider>
      </CacheProvider>
    </DirectionContext.Provider> 
  );
}

export default App;
